import {createContext} from 'react'

type AppContextType = {
  podsData: any
  getPodsData: () => void
  isLoading: boolean
  stripeCusId: string
}

const AppContext = createContext<AppContextType>({
  podsData: [],
  getPodsData: () => {},
  isLoading: true,
  stripeCusId: '',
})

export default AppContext
